<template>
  <div class="maintenancePage">
    

    <b-modal size="xl" ref="sensor-modal" 
      :title="(inModifyMode ? 'Modifica' : 'Crea') + ' sensore'"
      :ok-title="inModifyMode ? 'Modifica' : 'Crea'"
      @close="onChangeSensor(null)"
      @clanel="onChangeSensor(null)"
      @ok="onOkSensor">

      
      <sensor-details 
        :sensor="selectedSensor"
        :machine-list="machineList"
        @deleteSensor="onDeleteSensor"
        
         />
      

      
    </b-modal>  

    <div class="clearfix">
      <v-btn
        depressed
        color="primary"
        @click="newSensor"
      >
      Nuovo Sensore <i class="fa fa-plus"></i>
      </v-btn>
    </div>
    <sensor-list 
      @sensorChanged="onChangeSensor"
      :list="sensorList" 
      :machine-list="machineList"
    />
    
  </div>
</template>

<script>
import SensorList from "@/components/sensor/SensorList.vue";
import SensorDetails from "@/components/sensor/SensorDetails.vue";
//import MaintenanceDettails from "@/components/maintenance/MaintenanceDettails.vue";

import { mapState } from "vuex";
import sensorService from "../services/sensor";

export default {
  name: "SensorView",
  data() {
    return {
      selectedSensor: null
    };
  },
  mounted() {
    this.$store.dispatch("sensorModule/loadSensors");
    //this.$store.dispatch("maintenanceModule/loadMaintenances");
    //this.$store.dispatch("machineModule/loadMachines");
  },
  computed: {
    ...mapState("sensorModule", {
      sensorList: function(state) {
        return state.sensorList;
      }
    }),
    ...mapState("machineModule", {
      machineList: function(state) {
        return state.machineList;
      }
    }),
    inModifyMode() {
      return !!(this.selectedSensor && this.selectedSensor._id)
    }
  },
  methods: {
    async onOkSensor() {
      if(!this.selectedSensor)
        return;
      if(this.selectedSensor._id) {
        await sensorService.updatesensor(this.selectedSensor)
      } else {
        await sensorService.createsensor(this.selectedSensor)
      }
      
      this.$store.dispatch("sensorModule/loadSensors");
    },
    onChangeSensor(sensor) {
      if(sensor) {
        this.selectedSensor = JSON.parse(JSON.stringify(sensor));        
        this.$refs['sensor-modal'].show()
      } else {       
        this.selectedSensor = null; 
        this.$refs['sensor-modal'].hide()
      }
    },
    newSensor(){
        this.onChangeSensor({})
    },
    async onDeleteSensor(sensor) {
      console.log('Deleting?');
      if(!this.selectedSensor || !this.selectedSensor._id || this.selectedSensor._id !== sensor._id)
        return;
      if(!confirm("Confermi di voler cancellare questa spare")) {
        return;
      }
      await sensorService.deleteSensor(this.selectedSensor._id)
      this.$store.dispatch("sensorModule/loadSensors");
      this.selectedSensor = null; 
      this.$refs['sensor-modal'].hide()
    },
  },
  components: {
    SensorList,
    SensorDetails
    
    
  }
};
</script>

